module.exports = __webpack_public_path__ + "media/images/athletes/1682-601c5feb17b020b91831f91faa9ca934.png";